export const Languages = [
  'ar',
  'br',
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'et',
  'fi',
  'fr_CA',
  'fr',
  'hr',
  'hu',
  'it',
  'li',
  'lt',
  'lv',
  'nl',
  'nn',
  'no',
  'pl',
  'pt',
  'pt_BR',
  'ro',
  'se',
  'sk',
  'sl',
  'sv',
  'tr',
  'us',
] as const

export type Languages = (typeof Languages)[number]
